export const getCategoryIconName = (category = '') => {
  const name = category.toLowerCase();
  
  if (/(pizza|pasta|spaghetti|lasagna)/i.test(name)) return 'Pizza';
  if (/(dessert|sweet|icecream|pudding|cake|pastry|cookie|donut|waffle)/i.test(name)) return 'Dessert';
  if (/(burger|sandwich|subway|panini|fries|nugget)/i.test(name)) return 'Sandwich';
  if (/(coffee|tea|hot|latte|cappuccino|espresso|chai|mocha)/i.test(name)) return 'Coffee';
  if (/(drink|beverage|juice|shake|smoothie|water|soda|cola|milk|cold|ice|beer|wine|cocktail|mojito)/i.test(name)) return 'CupSoda';
  if (/(soup|stew|broth|ramen|shorba)/i.test(name)) return 'Soup';
  if (/(salad|green|healthy|diet)/i.test(name)) return 'Salad';
  if (/(bread|bakery|croissant|roti|naan|bun|toast)/i.test(name)) return 'Croissant';
  if (/(fish|shrimp|prawn|crab|lobster|seafood)/i.test(name)) return 'Fish';
  if (/(chicken|poultry|turkey|wing|drumstick)/i.test(name)) return 'Drumstick';
  if (/(beef|pork|mutton|steak|rib)/i.test(name)) return 'Beef';
  
  return 'Utensils'; // Default fallback icon
};
